/**
 * EDMS Settings Tabs – main landing for EDMS Settings.
 * Follows same structure as Project Settings: PageHeader (app > module) + content section.
 */
import React from 'react';
import PageHeader from '../../components/shared/PageHeader';
import Tabs from '../../components/shared/Tabs';
import RepositoriesPage from '../../components/admin/edmsSettings/repositories/RepositoriesPage';
import FolderTypesPage from '../../components/admin/edmsSettings/folderTypes/FolderTypesPage';
import DocumentTypesPage from '../../components/admin/edmsSettings/documentTypes/DocumentTypesPage';
import DocumentTypeFieldsPage from '../../components/admin/edmsSettings/documentTypeFields/DocumentTypeFieldsPage';

const APP_ID = 'documents-management';
const APP_NAME = 'Documents Management';
const MODULE = 'Settings';

const EdmsSettingTabs = () => (
  <>
    <PageHeader
      title={`${APP_NAME} | ${MODULE}`}
      breadcrumbItems={[
        { label: APP_NAME, href: `/app/${APP_ID}` },
        { label: MODULE },
      ]}
    />
    <div className="rounded-2xl border border-cream/60 bg-white shadow-sm overflow-hidden">
      <div className="p-6 pt-4">
        <Tabs
          tabs={[
            { id: 'repositories', label: 'Repositories', children: <RepositoriesPage /> },
            { id: 'folderTypes', label: 'Folder Types', children: <FolderTypesPage /> },
            { id: 'documentTypes', label: 'Document Types', children: <DocumentTypesPage /> },
            {
              id: 'documentTypeFields',
              label: 'Document Type Fields',
              children: <DocumentTypeFieldsPage />,
            },
          ]}
          defaultTabId="repositories"
          panelClassName="rounded-b-xl"
        />
      </div>
    </div>
  </>
);

export default EdmsSettingTabs;
